import { render, staticRenderFns } from "./PortalRejestracja.vue?vue&type=template&id=855f248a&"
import script from "./PortalRejestracja.vue?vue&type=script&lang=js&"
export * from "./PortalRejestracja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports